const initMarquee = () => {
  // // Select all swiper slides
  // const slides = document.querySelectorAll('.mh_isaak_shop_ftrmarquee_slider .swiper-slide');

  // if (slides.length === 0) return;

  // slides.forEach((slide, index) => {
  //   // Select the container holding the marquee content
  //   const marqueeContent = slide.querySelector('.mh_isaak_shop_ftrmrq_slide_block');

  //   if (!marqueeContent) return;

  //   // Determine the duration for the marquee animation
  //   // You can set a default duration or use a data attribute on the swiper-slide
  //   const durationAttr = slide.getAttribute('data-marquee-duration');
  //   const duration = durationAttr && !isNaN(durationAttr) ? parseFloat(durationAttr) : 20; // default to 20 seconds

  //   // Clone the marquee blocks to ensure seamless scrolling
  //   const marqueeBlocks = slide.querySelectorAll('.mh_isaak_shop_ftrmrq_slide_block');
  //   const marqueeClone = document.createElement('div');
  //   marqueeClone.classList.add('mh_isaak_shop_ftrmrq_slide_block', 'marquee-clone');
  //   marqueeBlocks.forEach(block => {
  //     const clone = block.cloneNode(true);
  //     marqueeClone.appendChild(clone);
  //   });
  //   slide.appendChild(marqueeClone);

  //   // Wrap all marquee blocks in a container if not already wrapped
  //   let marqueeWrapper = slide.querySelector('.marquee-wrapper');
  //   if (!marqueeWrapper) {
  //     marqueeWrapper = document.createElement('div');
  //     marqueeWrapper.classList.add('marquee-wrapper', 'd-flex');
  //     // Move all existing marquee blocks into the wrapper
  //     marqueeBlocks.forEach(block => marqueeWrapper.appendChild(block));
  //     marqueeClone.querySelectorAll('.mh_isaak_shop_ftrmrq_slide_block').forEach(cloneBlock => {
  //       marqueeWrapper.appendChild(cloneBlock);
  //     });
  //     slide.appendChild(marqueeWrapper);
  //   }

  //   // Apply GSAP animation to the marquee wrapper
  //   gsap.to(marqueeWrapper, {
  //     x: "-50%", // Adjust based on the number of clones and content width
  //     repeat: -1,
  //     duration: duration,
  //     ease: 'linear'
  //   });
  // });


  var jdMarqueeSlider = new Swiper(
    ".mh_isaak_shop_ftrmarquee_slider",
    {
      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      speed: 7000,
      grabCursor: false,
      mousewheelControl: false,
      draggable: false,
      keyboardControl: false,
      simulateTouch: false,
      navigation: false
    }
  );
};

// Initialize the marquee after the DOM content is loaded
document.addEventListener('DOMContentLoaded', initMarquee);



document.addEventListener("DOMContentLoaded", function () {
  var shopProductCartDrawerRecomSlider = new Swiper(
    ".mh_isaak_cart_drawer_product_recommendation_carousel",
    {
      slidesPerView: 1, // Default number of slides for larger screens
      spaceBetween: 0,
      loop: true,
      // Enable navigation arrows
      navigation: {
        nextEl:
          ".mh_isaak_cart_drawer_product_recommendation_carousel_next",
        prevEl:
          ".mh_isaak_cart_drawer_product_recommendation_carousel_prev",
      },
    }
  );
});

$(document).ready(function () {
    // Add .active class
    $(".mh_isaak_collection_products_grid_filter_mobile_detailed_filter_block").click(function () {
        $(".mh_isaak_collection_products_grid_filter_overlay").addClass("active");
    });

    // Remove .active class
    $(".mh_isaak_collection_products_grid_filter_header_cross_block").click(function () {
        $(".mh_isaak_collection_products_grid_filter_overlay").removeClass("active");
    });
});

$(document).ready(function () {

  const minPrice = parseFloat($("#price-min").val()) || 0;
  const maxPrice = parseFloat($("#price-max").val()) || 0;

  // If the filter.range_max was inserted into #price-max, 
  // you can also set a variable for the absolute maximum.
  // E.g., from your Liquid: filter.range_max | money_without_currency
  const absoluteMax = maxPrice > 0 ? maxPrice : 1000; // fallback if needed

  $("#price-range-slider").slider({
    range: true,
    min: 0,
    max: absoluteMax,
    values: [minPrice, maxPrice],
    slide: function (event, ui) {
      // When user slides, update hidden fields + the visual display
      $("#price-min").val(ui.values[0]);
      $("#price-max").val(ui.values[1]);

      $("#price-min-display").text(ui.values[0]);
      $("#price-max-display").text(ui.values[1]);
    },
    // If you want the filter to automatically trigger on stopping the slider:
    change: function (event, ui) {
      // Trigger the form change event so your AJAX can run
      // if you want immediate updates whenever the slider is released
      $("#ajax-filter-form input#price-min").trigger("change");
    },
  });

  
  // 1. Toggle filter visibility
  $(".filter-header").click(function () {
    $(this).next(".filter-content").slideToggle();
  });

  // 2. AJAX filter update on input change
  $("#ajax-filter-form input, #ajax-filter-form select").on("change", function () {
    const form = $("#ajax-filter-form");
    const url = `${window.location.pathname}?${form.serialize()}`;

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function () {
        $("#ajax-product-grid").addClass("loading");
      },
      success: function (response) {
        // Update product grid
        const newGrid = $(response).find("#ajax-product-grid").html();
        $("#ajax-product-grid").html(newGrid);

        // Update active filters or "Clear all" block
        const newFilters = $(response).find(".filter-clear-all").html();
        $(".filter-clear-all").html(newFilters);

        $("#ajax-product-grid").removeClass("loading");
      },
      error: function () {
        alert("There was an error processing the filters.");
      },
    });
  });

  // 3. AJAX clear filters
  //    (e.g., "Clear all" or removing an individual active filter)
  $(document).on("click", ".mh_collection_clearbtn, .mh_collection_filter_tag_clear_block a", function (e) {
    e.preventDefault();

    const url = $(this).attr("href");

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function () {
        $("#ajax-product-grid").addClass("loading");
      },
      success: function (response) {
        // Update product grid
        const newGrid = $(response).find("#ajax-product-grid").html();
        $("#ajax-product-grid").html(newGrid);

        // Update active filters or "Clear all" block
        const newFilters = $(response).find(".filter-clear-all").html();
        $(".filter-clear-all").html(newFilters);

        $("#ajax-product-grid").removeClass("loading");
      },
      error: function () {
        alert("There was an error resetting the filters.");
      },
    });
  });

  // 4. AJAX pagination
  //    Intercepts clicks on pagination links rendered by {% render 'pagination' %}
  $(document).on("click", ".mh_collection_pagination a", function (e) {
    e.preventDefault();

    const url = $(this).attr("href");

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function () {
        $("#ajax-product-grid").addClass("loading");
      },
      success: function (response) {
        // Replace product grid with the new page’s content
        const newGrid = $(response).find("#ajax-product-grid").html();
        $("#ajax-product-grid").html(newGrid);

        // Update pagination (in case the number of pages changed or new links are generated)
        const newPagination = $(response).find(".mh_collection_pagination").html();
        $(".mh_collection_pagination").html(newPagination);

        $("#ajax-product-grid").removeClass("loading");
      },
      error: function () {
        alert("There was an error loading the next page.");
      },
    });
  });
});



$(document).ready(function () {
  // Initially hide all FAQ bodies
  $(".mh_isaak_faq_item_body").hide();

  // Show the first FAQ body by default
  $(".mh_isaak_faq_item_block").first().find(".mh_isaak_faq_item_body").show();

  // Add 'active' class to the first FAQ item
  $(".mh_isaak_faq_item_block").first().addClass("active");

  // Set up click handler for FAQ item blocks
  $(".mh_isaak_faq_item_block").on("click", function () {
    // Check if the clicked item is already active
    if ($(this).hasClass("active")) {
      // If active, slide up the body and remove 'active' class
      $(this).find(".mh_isaak_faq_item_body").slideUp();
      $(this).removeClass("active");
    } else {
      // Close all other FAQ bodies and remove their 'active' classes
      $(".mh_isaak_faq_item_body").slideUp();
      $(".mh_isaak_faq_item_block").removeClass("active");

      // Slide down the clicked FAQ body and add 'active' class
      $(this).find(".mh_isaak_faq_item_body").slideDown();
      $(this).addClass("active");
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   let SwiperTop = new Swiper(".mh_isaak_shop_ftrmarquee_slider", {
//     spaceBetween: 20,
//     centeredSlides: true,
//     speed: 25000,
//     autoplay: {
//       delay: 0,
//       disableOnInteraction: false,
//       pauseOnMouseEnter: false,
//     },
//     loop: true,
//     slidesPerView: "auto",
//     allowTouchMove: false,
//   });

//   // Optionally start autoplay manually
//   SwiperTop.autoplay.start();
// });

document.addEventListener("DOMContentLoaded", function () {
  var shopProductsCarousel = new Swiper(".mh_isaak_shop_products_carousel", {
    slidesPerView: 4.1, // Number of slides per view
    spaceBetween: 20, // Space between slides in pixels
    loop: true, // Enable looping
    // Optional: Add navigation arrows
    navigation: {
      nextEl: ".mh_isaak_shop_products_carousel_next",
      prevEl: ".mh_isaak_shop_products_carousel_prev",
    },
    // Responsive breakpoints (optional)
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2.2,
        spaceBetween: 15,
      },
      // when window width is >= 640px
      768: {
        slidesPerView: 3.15,
        spaceBetween: 20,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 4.15,
        spaceBetween: 20,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var shopCollectionsCarousel = new Swiper(
    ".mh_isaak_shop_collection_carousel",
    {
      slidesPerView: 4, // Number of slides per view
      spaceBetween: 20, // Space between slides in pixels
      loop: true, // Enable looping
      // Enable pagination
      pagination: {
        el: ".mh_isaak_shop_collection_carousel_pagination",
        clickable: true,
      },
      // Enable navigation arrows
      navigation: {
        nextEl: ".mh_isaak_shop_collection_carousel_next",
        prevEl: ".mh_isaak_shop_collection_carousel_prev",
      },
      breakpoints: {
        // when window width is >= 320px
        0: {
          slidesPerView: 1.15,
          spaceBetween: 15,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        // when window width is >= 640px
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 1024px
        1120: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    }
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var shopReviewsCarousel = new Swiper(".mh_isaak_shop_reviews_carousel", {
    slidesPerView: 3, // Number of slides per view
    spaceBetween: 20, // Space between slides in pixels
    loop: true,
    // Enable pagination
    pagination: {
      el: ".mh_isaak_shop_reviews_carousel_pagination",
      clickable: true,
    },
    // Enable navigation arrows
    navigation: {
      nextEl: ".mh_isaak_shop_reviews_carousel_next",
      prevEl: ".mh_isaak_shop_reviews_carousel_prev",
    },
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      420: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      // when window width is >= 1024px
      1120: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
});

jQuery(window).on("load resize", function () {
  // 1. Find the maximum height in .mh_isaak_shop_reviews_slide_content_block
  let mh_isaak_review_carousel_maxHeight = 0;

  jQuery(".mh_isaak_shop_reviews_slide_content_block").each(function () {
    let mh_isaak_review_carousel_thisHeight = jQuery(this).outerHeight();
    if (
      mh_isaak_review_carousel_thisHeight > mh_isaak_review_carousel_maxHeight
    ) {
      mh_isaak_review_carousel_maxHeight = mh_isaak_review_carousel_thisHeight;
    }
  });

  // 2. Apply that max height as min-height (applies to all screen sizes)
  jQuery(".mh_isaak_shop_reviews_slide_content_block").css(
    "height",
    mh_isaak_review_carousel_maxHeight
  );

  // 3. Check if viewport width > 768px
  let mh_isaak_review_carousel_windowWidth = jQuery(window).width();
  if (mh_isaak_review_carousel_windowWidth > 768) {
    // Get the total height of .mh_isaak_shop_reviews_content_wrapper
    let mh_isaak_review_carousel_wrapperHeight = jQuery(
      ".mh_isaak_shop_reviews_content_wrapper"
    ).outerHeight();

    // Subtract the max height from the wrapper's height
    let mh_isaak_review_carousel_diffHeight =
      mh_isaak_review_carousel_wrapperHeight -
      mh_isaak_review_carousel_maxHeight;

    // Prevent negative heights if the wrapper is smaller than the content block
    if (mh_isaak_review_carousel_diffHeight < 0) {
      mh_isaak_review_carousel_diffHeight = 0;
    }

    // Apply the resulting value as the height of .mh_isaak_shop_reviews_slide_img_block img
    jQuery(".mh_isaak_shop_reviews_slide_img_block").css(
      "height",
      mh_isaak_review_carousel_diffHeight
    );
  }
});

$(document).ready(function () {
  function mh_shop_carousel_updateCarouselBlockMargin() {
    // Select the primary-container div
    var $mh_shop_carousel_primaryContainer = $(".primary-container");

    // Retrieve the margin-left and padding-left values
    var mh_shop_carousel_marginLeft =
      parseInt($mh_shop_carousel_primaryContainer.css("margin-left"), 10) || 0;
    var mh_shop_carousel_paddingLeft =
      parseInt($mh_shop_carousel_primaryContainer.css("padding-left"), 10) || 0;

    // Calculate the sum
    var mh_shop_carousel_totalLeft =
      mh_shop_carousel_marginLeft + mh_shop_carousel_paddingLeft;

    // Select the mh_isaak_shop_products_carousel_block div
    var $mh_shop_carousel_block = $(".mh_isaak_shop_products_carousel_block");

    // Apply the sum to the carousel block as a left margin
    $mh_shop_carousel_block.css(
      "margin-left",
      mh_shop_carousel_totalLeft + "px"
    );

   
  }

  // Initial call to set the margin when the document is ready
  mh_shop_carousel_updateCarouselBlockMargin();

  // Update the margin on window resize
  $(window).resize(function () {
    mh_shop_carousel_updateCarouselBlockMargin();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var shopHeroContentCarousel = new Swiper(
    ".shop_hero_banner_content_carousel",
    {
      loop: true, // Enable looping of slides
      effect: "fade", // Set the effect to fade
      fadeEffect: {
        crossFade: true, // Enable crossfade between slides
      },
      // Enable pagination
      pagination: {
        el: ".shop_hero_banner_content_pagination",
        clickable: true,
      },
      // Enable navigation arrows
      navigation: {
        nextEl: ".shop_hero_banner_content_next",
        prevEl: ".shop_hero_banner_content_prev",
      },
    }
  );
  var shopHeroImageCarousel = new Swiper(".shop_hero_banner_images_carousel", {
    loop: true, // Enable looping of slides
    effect: "fade", // Set the effect to fade
    fadeEffect: {
      crossFade: true, // Enable crossfade between slides
    },
  });
  shopHeroContentCarousel.controller.control = shopHeroImageCarousel;
  shopHeroImageCarousel.controller.control = shopHeroContentCarousel;
});

$(document).ready(function () {
  // Get the computed left margin and padding of .primary-container
  var mh_isaak_hero_cont_margin_left = parseInt(
    $(".primary-container").css("margin-left"),
    10
  );
  var mh_isaak_hero_cont_padding_left = parseInt(
    $(".primary-container").css("padding-left"),
    10
  );

  // Calculate the sum
  var mh_isaak_hero_cont_sum =
    mh_isaak_hero_cont_margin_left + mh_isaak_hero_cont_padding_left;

  // Apply the sum to the left margin and padding of .shop_hero_banner_content_block
  $(".shop_hero_banner_content_block").css({
    "padding-left": mh_isaak_hero_cont_sum + "px",
  });
});


jQuery(document).ready(function ($) {
  function toggleFooterNavigationBehavior() {
    let windowWidth = $(window).width();

    if (windowWidth < 768) {
      // Hide all blocks except the first one below 768px
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item_list_block"
      ).hide();
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item.d-flex"
      ).removeClass("active");
      $(".mh_isaak_shop_footer_upper_sitenavigation_links_item:first-child")
        .addClass("active")
        .find(
          ".mh_isaak_shop_footer_upper_sitenavigation_links_item_list_block"
        )
        .show();

      // Bind click event to the heading icon
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item_heading_block .mh_isaak_shop_footer_upper_sitenavigation_links_item_heading_icon"
      )
        .off("click")
        .on("click", function () {
          let parentItem = $(this).closest(
            ".mh_isaak_shop_footer_upper_sitenavigation_links_item.d-flex"
          );
          let listBlock = parentItem.find(
            ".mh_isaak_shop_footer_upper_sitenavigation_links_item_list_block"
          );

          // Close all blocks except the clicked one
          $(".mh_isaak_shop_footer_upper_sitenavigation_links_item_list_block")
            .not(listBlock)
            .slideUp();
          $(".mh_isaak_shop_footer_upper_sitenavigation_links_item.d-flex")
            .not(parentItem)
            .removeClass("active");

          // Toggle the clicked block and active class on the parent item
          listBlock.slideToggle();
          parentItem.toggleClass("active");
        });
    } else {
      // Show all blocks and unbind click events above 768px
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item_list_block"
      ).show();
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item.d-flex"
      ).removeClass("active");
      $(
        ".mh_isaak_shop_footer_upper_sitenavigation_links_item_heading_block .mh_isaak_shop_footer_upper_sitenavigation_links_item_heading_icon"
      ).off("click");
    }
  }

  // Run on page load
  toggleFooterNavigationBehavior();

  // Re-run on window resize
  $(window).on("resize", function () {
    toggleFooterNavigationBehavior();
  });
});

$(document).ready(function () {
  // Get the left margin and padding of the .tertiary-container
  var mh_contact_info_margin_left = parseInt(
    $(".primary-container").css("margin-left"),
    10
  );
  var mh_contact_info_padding_left = parseInt(
    $(".primary-container").css("padding-left"),
    10
  );

  // Sum the margin and padding
  var mh_contact_info_combined_value =
    mh_contact_info_margin_left + mh_contact_info_padding_left;

  // Apply the sum as left padding to the .mh_isaak_contact_info_block
  $(".mh_isaak_contact_info_block").css(
    "padding-left",
    mh_contact_info_combined_value + "px"
  );
});

$(document).ready(function () {
  // Get the left and right margins of the .primary-container
  var mh_contact_form_margin_left = parseInt(
    $(".primary-container").css("margin-left"),
    10
  );
  var mh_contact_form_margin_right = parseInt(
    $(".primary-container").css("padding-right"),
    10
  );

  // Sum the left and right margins
  var mh_contact_form_combined_margin =
    mh_contact_form_margin_left + mh_contact_form_margin_right;

  // Apply the combined margin as left padding to the .mh_isaak_contact_form_block
  $(".mh_isaak_contact_form_block").css(
    "padding-right",
    mh_contact_form_combined_margin + "px"
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var shopProductFeaturesCarousel = new Swiper(
    ".mh_isaak_product_features_carousel",
    {
      slidesPerView: 4, // Default number of slides for larger screens
      spaceBetween: 0,
      breakpoints: {
        0: {
          slidesPerView: 1, // 0px to 479px
          spaceBetween: 20, // Optional: Adjust spacing for smaller screens
        },
        520: {
          slidesPerView: 2, // 480px to 767px
          spaceBetween: 15, // Optional: Adjust spacing for medium screens
        },
        768: {
          slidesPerView: 3, // 768px and above
          spaceBetween: 30, // Restore default spacing
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
      // Enable navigation arrows
      navigation: {
        nextEl: ".mh_isaak_shop_product_features_carousel_next",
        prevEl: ".mh_isaak_shop_product_features_carousel_prev",
      },
    }
  );
});

$(document).ready(function () {
  // Select all submenu wrappers
  var mh_isaak_submenuWrappers = $(
    ".mh_isaak_shop_header_navbar_list_item_sub_menu_wrapper"
  );
  // Select all li elements with submenus
  var mh_isaak_menuItems = $(
    ".mh_isaak_shop_header_navbar_list_hassubitem_block"
  );

  // Initially hide all submenu wrappers and ensure pointer-events are disabled
  mh_isaak_submenuWrappers
    .css("opacity", "0")
    .css("visibility", "hidden")
    .css("pointer-events", "none");

  // Iterate over each submenu wrapper to handle their corresponding li
  mh_isaak_submenuWrappers.each(function (index) {
    var mh_isaak_submenu = $(this);
    var mh_isaak_menuItem = mh_isaak_menuItems.eq(index);

    // Variables to track hover state
    var mh_isaak_isHoveringMenuItem = false;
    var mh_isaak_isHoveringSubmenu = false;

    // Function to show submenu
    function mh_isaak_showSubmenu() {
      mh_isaak_submenu
        .css("opacity", "1")
        .css("visibility", "visible")
        .css("pointer-events", "auto");

      // Activate the first image block when submenu is shown
      var mh_isaak_firstImage = mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listitem_images_block"
        )
        .first();
      var mh_isaak_firstParagraph = mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listlinks_block p"
        )
        .first();

      mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listitem_images_block"
        )
        .removeClass("active")
        .css("opacity", "0")
        .css("pointer-events", "none");
      mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listlinks_block p"
        )
        .removeClass("active");

      mh_isaak_firstImage
        .addClass("active")
        .css("opacity", "1")
        .css("pointer-events", "auto");
      mh_isaak_firstParagraph.addClass("active");
    }

    // Function to hide submenu
    function mh_isaak_hideSubmenu() {
      mh_isaak_submenu
        .css("opacity", "0")
        .css("visibility", "hidden")
        .css("pointer-events", "none");

      // Deactivate all image blocks when submenu is hidden
      mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listitem_images_block"
        )
        .removeClass("active")
        .css("opacity", "0")
        .css("pointer-events", "none");
      mh_isaak_submenu
        .find(
          ".mh_isaak_shop_header_navbar_list_item_sub_menu_listlinks_block p"
        )
        .removeClass("active");
    }

    // Mouse enter on menu item
    mh_isaak_menuItem.on("mouseenter", function () {
      mh_isaak_isHoveringMenuItem = true;
      mh_isaak_showSubmenu();
    });

    // Mouse leave on menu item
    mh_isaak_menuItem.on("mouseleave", function () {
      mh_isaak_isHoveringMenuItem = false;
      // Delay hiding to allow mouse to enter submenu
      setTimeout(function () {
        if (!mh_isaak_isHoveringSubmenu && !mh_isaak_isHoveringMenuItem) {
          mh_isaak_hideSubmenu();
        }
      }, 100);
    });

    // Mouse enter on submenu
    mh_isaak_submenu.on("mouseenter", function () {
      mh_isaak_isHoveringSubmenu = true;
      mh_isaak_showSubmenu();
    });

    // Mouse leave on submenu
    mh_isaak_submenu.on("mouseleave", function () {
      mh_isaak_isHoveringSubmenu = false;
      // Delay hiding to allow mouse to enter menu item
      setTimeout(function () {
        if (!mh_isaak_isHoveringSubmenu && !mh_isaak_isHoveringMenuItem) {
          mh_isaak_hideSubmenu();
        }
      }, 100);
    });

    // Handle image display within submenu
    // Select all image blocks within the current submenu
    var mh_isaak_imageBlocks = mh_isaak_submenu.find(
      ".mh_isaak_shop_header_navbar_list_item_sub_menu_listitem_images_block"
    );

    // Select all <p> elements within the current submenu's link blocks
    var mh_isaak_paragraphs = mh_isaak_submenu.find(
      ".mh_isaak_shop_header_navbar_list_item_sub_menu_listlinks_block p"
    );

    // Remove any default active classes and ensure all image blocks are hidden
    mh_isaak_imageBlocks
      .removeClass("active")
      .css("opacity", "0")
      .css("pointer-events", "none");
    mh_isaak_paragraphs.removeClass("active");

    // Variable to keep track of the currently active image within the current submenu
    var mh_isaak_currentIndex = 0;

    // Function to handle image activation
    function mh_isaak_activateImage(index) {
      if (index === mh_isaak_currentIndex) {
        return; // Do nothing if the same <p> is hovered
      }
      // Remove 'active' class from the current image and paragraph
      mh_isaak_imageBlocks
        .eq(mh_isaak_currentIndex)
        .removeClass("active")
        .css("opacity", "0")
        .css("pointer-events", "none");
      mh_isaak_paragraphs.eq(mh_isaak_currentIndex).removeClass("active");
      // Add 'active' class to the new image and paragraph
      mh_isaak_imageBlocks
        .eq(index)
        .addClass("active")
        .css("opacity", "1")
        .css("pointer-events", "auto");
      mh_isaak_paragraphs.eq(index).addClass("active");
      // Update the current index
      mh_isaak_currentIndex = index;
    }

    // Handle hover events on paragraphs
    mh_isaak_paragraphs.hover(
      function () {
        // Mouse enter
        var mh_isaak_newIndex = mh_isaak_paragraphs.index(this);
        mh_isaak_activateImage(mh_isaak_newIndex);
      },
      function () {
        // Mouse leave
        // Do nothing to retain the last hovered image
      }
    );

    // Handle focus events for keyboard navigation
    mh_isaak_paragraphs.find("a").focus(function () {
      var mh_isaak_newIndex = mh_isaak_paragraphs.index($(this).closest("p"));
      mh_isaak_activateImage(mh_isaak_newIndex);
    });
  });
});

$(document).ready(function () {
  // On click of hamburger block => add "active" to menu drawer
  $(".mh_isaak_shop_header_navbar_upper_hamburger_block").on(
    "click",
    function () {
      $(".mh_isaak_shop_menu_drawer_wrapper").addClass("active");
      $("body, html").addClass("mobile-shop-menu-active");
    }
  );

  // On click of remove block => remove "active" from menu drawer
  $(".mh_isaak_shop_menu_drawer_remove_block").on("click", function () {
    $(".mh_isaak_shop_menu_drawer_wrapper").removeClass("active");
    $("body, html").removeClass("mobile-shop-menu-active");
  });
});

$(document).ready(function () {
  // Prefix: mh_isaak_prod_einfo

  // 1. Hide all bodies
  var mh_isaak_prod_einfo_allBodies = $(
    ".mh_isaak_shop_main_product_einfo_body_block"
  );
  mh_isaak_prod_einfo_allBodies.hide();

  // Keep track of the currently open body
  var mh_isaak_prod_einfo_currentlyOpen = null;

  // 2. On heading click
  $(".mh_isaak_shop_main_product_einfo_heading_block").on("click", function () {
    // Get the parent block and the body to slide
    var mh_isaak_prod_einfo_parentBlock = $(this).closest(
      ".mh_isaak_shop_main_product_einfo_block"
    );
    var mh_isaak_prod_einfo_body = mh_isaak_prod_einfo_parentBlock.find(
      ".mh_isaak_shop_main_product_einfo_body_block"
    );

    // If the clicked block is already open, slide it up & remove "active"
    if (mh_isaak_prod_einfo_body.is(":visible")) {
      mh_isaak_prod_einfo_body.slideUp();
      mh_isaak_prod_einfo_parentBlock.removeClass("active");
      mh_isaak_prod_einfo_currentlyOpen = null;
    } else {
      // Slide up previously open body (if any) & remove "active" from its parent
      if (
        mh_isaak_prod_einfo_currentlyOpen &&
        mh_isaak_prod_einfo_currentlyOpen.length
      ) {
        mh_isaak_prod_einfo_currentlyOpen.slideUp();
        mh_isaak_prod_einfo_currentlyOpen
          .closest(".mh_isaak_shop_main_product_einfo_block")
          .removeClass("active");
      }

      // Slide down the newly clicked body & add "active"
      mh_isaak_prod_einfo_body.slideDown();
      mh_isaak_prod_einfo_parentBlock.addClass("active");

      // Update the currently open body reference
      mh_isaak_prod_einfo_currentlyOpen = mh_isaak_prod_einfo_body;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const productThumbnailSwiper = new Swiper(
    ".mh_isaak_shop_main_product_media_thumbnail_carousel",
    {
      slidesPerView: 5,
      spaceBetween: 0,
      breakpoints: {
        0: {
          slidesPerView: 3.45,
          spaceBetween: 12.5,
        },
        480: {
          slidesPerView: 5,
          spaceBetween: 12.5,
        },
      },
    }
  );

  const productMainSwiper = new Swiper(
    ".mh_isaak_shop_main_product_media_main_carousel",
    {
      spaceBetween: 0,
      thumbs: {
        swiper: productThumbnailSwiper,
      },
    }
  );
});

$(document).ready(function () {
  // Hide all submenus by default
  $(".mh_isaak_shop_menu_drawer_megamenu_link_submenu_block").hide();

  // Add click event to menu items with submenus
  $(".mh_isaak_shop_menu_drawer_megamenu_hassubmenu_link_block").on(
    "click",
    function () {
      // Define variables with the specified prefix
      var mh_isaak_nav_mobile_toggle_current = $(this);
      var mh_isaak_nav_mobile_toggle_submenu =
        mh_isaak_nav_mobile_toggle_current.find(
          ".mh_isaak_shop_menu_drawer_megamenu_link_submenu_block"
        );

      // Check if the submenu is already visible
      if (mh_isaak_nav_mobile_toggle_submenu.is(":visible")) {
        // Hide the submenu if it is visible
        mh_isaak_nav_mobile_toggle_submenu.slideUp();
        mh_isaak_nav_mobile_toggle_current.removeClass("active");
      } else {
        // Hide all other open submenus and remove active class
        $(".mh_isaak_shop_menu_drawer_megamenu_link_submenu_block").slideUp();
        $(
          ".mh_isaak_shop_menu_drawer_megamenu_hassubmenu_link_block"
        ).removeClass("active");

        // Show the clicked submenu and add active class
        mh_isaak_nav_mobile_toggle_submenu.slideDown();
        mh_isaak_nav_mobile_toggle_current.addClass("active");
      }
    }
  );
});


(function () {
  function mhIsaakV2MediaIconCardsShowcaseInit(scope) {
    if (typeof Swiper === 'undefined') return;

    const root = scope || document;
    const swipers = root.querySelectorAll('[data-mh-isaak-v2-cards-showcase-swiper]');

    if (!swipers.length) return;

    swipers.forEach(function (el) {
      if (el.dataset.mhIsaakV2SwiperInit === 'true') return;
      el.dataset.mhIsaakV2SwiperInit = 'true';

      const paginationEl = el.querySelector('[data-mh-isaak-v2-cards-showcase-pagination]');
      const gapDesktop = parseFloat(el.getAttribute('data-gap-desktop')) || 16;
      const gapTablet = parseFloat(el.getAttribute('data-gap-tablet')) || gapDesktop;
      const gapMobile = parseFloat(el.getAttribute('data-gap-mobile')) || gapTablet;

      new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: gapMobile,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        centerInsufficientSlides: true,
        pagination: {
          el: paginationEl,
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: 2.4,
            spaceBetween: gapTablet
          },
          990: {
            slidesPerView: 4,
            spaceBetween: gapDesktop
          }
        }
      });
    });
  }

  function mhIsaakV2MediaIconCardsShowcaseBoot() {
    if (!document.querySelector('[data-mh-isaak-v2-cards-showcase-swiper]')) return;
    mhIsaakV2MediaIconCardsShowcaseInit(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mhIsaakV2MediaIconCardsShowcaseBoot);
  } else {
    mhIsaakV2MediaIconCardsShowcaseBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mhIsaakV2MediaIconCardsShowcaseInit(event.target);
  });
})();


(function () {
  function mhIsaakV2OverlayFeatureCardsInit(scope) {
    if (typeof Swiper === 'undefined') return;

    var root = scope || document;
    var swipers = root.querySelectorAll('[data-mh-isaak-v2-overlay-feature-cards-swiper]');

    if (!swipers.length) return;

    swipers.forEach(function (el) {
      // Prevent duplicate init
      if (el.mhIsaakV2OverlayFeatureCardsSwiper && !el.mhIsaakV2OverlayFeatureCardsSwiper.destroyed) return;

      var paginationEl = el.querySelector('[data-mh-isaak-v2-overlay-feature-cards-pagination]');

      var gapDesktop = parseFloat(el.getAttribute('data-gap-desktop')) || 16;
      var gapTablet = parseFloat(el.getAttribute('data-gap-tablet')) || gapDesktop;
      var gapMobile = parseFloat(el.getAttribute('data-gap-mobile')) || gapTablet;

      var slidesDesktop = parseFloat(el.getAttribute('data-slides-desktop')) || 3;
      var slidesTablet = parseFloat(el.getAttribute('data-slides-tablet')) || 2.4;
      var slidesMobile = parseFloat(el.getAttribute('data-slides-mobile')) || 1.2;

      var config = {
        slidesPerView: slidesMobile,
        spaceBetween: gapMobile,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        centerInsufficientSlides: true,
        breakpoints: {
          750: {
            slidesPerView: slidesTablet,
            spaceBetween: gapTablet
          },
          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop
          }
        }
      };

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      el.mhIsaakV2OverlayFeatureCardsSwiper = new Swiper(el, config);
    });
  }

  function mhIsaakV2OverlayFeatureCardsDestroy(scope) {
    var root = scope || document;
    var swipers = root.querySelectorAll('[data-mh-isaak-v2-overlay-feature-cards-swiper]');

    if (!swipers.length) return;

    swipers.forEach(function (el) {
      if (el.mhIsaakV2OverlayFeatureCardsSwiper && !el.mhIsaakV2OverlayFeatureCardsSwiper.destroyed) {
        el.mhIsaakV2OverlayFeatureCardsSwiper.destroy(true, true);
      }
      el.mhIsaakV2OverlayFeatureCardsSwiper = null;
    });
  }

  function mhIsaakV2OverlayFeatureCardsBoot() {
    if (!document.querySelector('[data-mh-isaak-v2-overlay-feature-cards-swiper]')) return;
    mhIsaakV2OverlayFeatureCardsInit(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mhIsaakV2OverlayFeatureCardsBoot);
  } else {
    mhIsaakV2OverlayFeatureCardsBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mhIsaakV2OverlayFeatureCardsInit(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    mhIsaakV2OverlayFeatureCardsDestroy(event.target);
  });
})();


$(document).ready(function () {

  if ($(window).width() <= 768) {
    $('.mh_isaak_shop_header_navbar_upper_search_block_trigger').click(function () {
      $('.mh_isaak_shop_header_navbar_upper_search_block')
        .stop(true, true)
        .slideToggle(300);
    });
  }

});